import { api } from './api';

export const fetchAccountById = (id) => {
  return api.get(`/account/${id}`);
};

export const fetchUpdateAccount = (id, payload) => {
  return api.put(`/account/${id}`, payload);
};
